import { h, Component } from 'preact';
import { configure } from '../../config';
import style from './style';
import cx from 'classnames';
import { onImageLoadCallback } from '@cube/performance';
import { createGenericTags, getProcessEventArgs, STANDARD_KEYS } from '@cube/track';
import dlv from 'dlv';

const heroTrackingVars = {
	'data-tracking-type': 'trackgif,appMeasurement',
	'data-tracking-zone': 'logo',
	'data-tracking-svalues-prop66': 'logo'
};

/**
 * This wrapper places a div and an optional a tag if an href is supplied.
 */
function LogoWrapper({ children, trackingVars, href, ...props }) {
	return (
		<div class={cx(style.logo, props.class)}>
			{
				href ?
					(
						<a
							class={style.link}
							{...trackingVars}
							href={href}
						>
							{children}
						</a>
					) : children
			}

		</div>
	);
}

export class Logo extends Component {
	getTrackingVars = () => {
		if (dlv(this.context, 'track.api.isUsingGenericAnalytics', false)) {
			return createGenericTags({
				[STANDARD_KEYS.cubecomponent]: 'LogoWidget',
				...dlv(this, 'context.trackingVars', {})
			}, getProcessEventArgs(this.context));
		}
		return heroTrackingVars;
	};

	getLogo = (baseUrl, theme, size, client) => {
		if (!size || !client) return '';
		return `${baseUrl}/images/${client}/logos/${theme}_${size}.png`;
	};

	render({ theme, size, clientOverride, streamClient, baseUrl, link, onImageLoad, suppressLink, ...props }) {
		// In order to allow a custom image, logo can be either a key into predefined logos, or a URL to a logo image.
		let logoSrc =  this.getLogo(baseUrl, theme || 'light', size, clientOverride || streamClient);

		if (logoSrc === '') {
			return;
		}

		onImageLoadCallback(logoSrc, onImageLoad);


		return (
			<LogoWrapper
				class={cx(props.class)}
				href={link}
				trackingVars={this.getTrackingVars()}
				suppressLink={suppressLink}
			>
				<span class={style.spacer} />
				<img src={logoSrc} />
			</LogoWrapper>
		);
	}
}

export default configure({
	baseUrl: 'logoConfig.baseUrl',
	clientOverride: 'logoConfig.clientOverride',
	streamClient: 'streamClient',
	link: 'logoConfig.link'
})(Logo);



// WEBPACK FOOTER //
// ../node_modules/@cube/logo-widget/src/components/logo/index.js